import React from 'react';
import { Checkbox } from '../widgets/beauty/input';
import ConfirmDialog from '../widgets/dialog/ConfirmDialog';

export default class ConfirmRemove extends ConfirmDialog {

  state = {
    hard: false
  }

  icon = () => 'alert';

  title = () => 'آیا میخواهید این دستگاه را حذف کنید؟';

  message = () => {
    return (
      <>
        <div className="confirm-remove-dialog mt-3">
          <div className="mr-2">
            <Checkbox
              checked={this.state.hard}
              text="لاگ های این دستگاه نیز حذف شوند"
              onChange={this.handleHardChange} />
          </div>
          <div>
            <hr style={{ margin: '1rem 0', borderColor: '#ddd' }} />
          </div>
        </div>
        <div className={"d-inline-flex mt-2 mr-auto"}>
          <button className="ant-btn ml-1" onClick={() => this.close()} autoFocus>خیر</button>
          <button
            className={"ant-btn ant-btn-danger"}
            onClick={() => { this.resolve(this.state.hard); this.close(); }}>
            حذف دستگاه
          </button>
        </div>
      </>
    );
  };

  private handleHardChange = () => {
    this.setState({ hard: !this.state.hard });
  }
}
